import { render, staticRenderFns } from "./OutOfCountryRequest.vue?vue&type=template&id=4f983d06&scoped=true&"
import script from "./OutOfCountryRequest.vue?vue&type=script&lang=js&"
export * from "./OutOfCountryRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f983d06",
  null
  
)

export default component.exports